
import { indexProjectBatchesOperation, indexBatchFilesOperation } from "@api/services/backstage"

export const listProjectBatches = async (request, projectId) => {
  const { data: projectBatches } = await request(indexProjectBatchesOperation, { projectId })

  return projectBatches
}

const listProjectFiles = async (request, projectId) => {
  const files = []

  const projectBatches = await listProjectBatches(request, projectId)

  // NOTE: Include only investor files and not project files.
  const investorBatches = projectBatches
    .filter(batch => !batch.fileUrl)

  const promises = investorBatches
    .map(({ id: batchId }) =>
      request(indexBatchFilesOperation, { batchId })
        .then(({ data: batchFiles }) => files.push(...batchFiles))
    )

  await Promise.all(promises)

  return [ investorBatches, files ]
}

export default listProjectFiles
